"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIPO_CLIENTE = void 0;
exports.TIPO_CLIENTE = { SIN_PREFIJOS: 1, CON_PREFIJOS: 2 };
